import React from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { CheckboxSelectionProps } from "models/propTypes/selectionPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { ButtonBase, Checkbox, FormControlLabel } from "@mui/material";
import useMultiSelectionHelpers from "./useMultiSelectionHelpers";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const CheckboxSelection: React.FC<CheckboxSelectionProps> = (props) => {
  const { items } = useMultiSelectionHelpers(props.items, props.value);

  const onChangeHandler = (e: React.ChangeEvent<any>) => {
    const id = e.target.value;
    const selected = items.filter((item) =>
      // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
      e.target.checked ? item.selected || item.id == id : item.selected && item.id != id
    );
    props.onChange && props.onChange(selected);
  };

  return (
    <>
      {items?.map((item: SelectionItem) => (
        <ButtonBase
          component="div"
          className={cssExports.checkboxSelection}
          TouchRippleProps={{ classes: { ripple: cssExports.touchRippleRoot } }}
          style={{ justifyContent: "flex-start" }}
        >
          <FormControlLabel
            className={item.selected ? cssExports.checked : ""}
            key={item.id}
            value={item.id}
            label={item.value}
            control={
              <Checkbox
                value={item.id}
                onChange={onChangeHandler}
                icon={<Icon icon={IconDefinitionConstants.WCheckbox} />}
                checkedIcon={<Icon icon={IconDefinitionConstants.WCheckboxChecked} />}
                classes={{ root: cssExports.checkboxRoot, checked: cssExports.checked }}
                disabled={props.readonly}
              />
            }
          />
        </ButtonBase>
      ))}
    </>
  );
};

export default CheckboxSelection;
